import FakeSoftphoneTransport from './FakeSoftphoneTransport'

export { SOFTPHONE_EVENTS, SoftphoneTransport } from './transport-contract'
export { FakeSoftphoneTransport }

export const SOFTPHONE_TRANSPORTS = Object.freeze({
  FAKE: 'fake',
  TELNYX: 'telnyx'
})

// Window key the dev/e2e hook is published under. Namespaced so it can't collide with app code.
export const SOFTPHONE_DEV_HOOK_KEY = '__ringbaxSoftphone__'

const isProductionBuild = process.env.NODE_ENV === 'production'

/**
 * Which transport to build. Real builds use the Telnyx SDK; everything else defaults to the
 * fake so local dev and tests never need media devices or a backend.
 */
export function getConfiguredTransportName() {
  const configured = process.env.VUE_APP_SOFTPHONE_TRANSPORT

  if (configured === SOFTPHONE_TRANSPORTS.FAKE || configured === SOFTPHONE_TRANSPORTS.TELNYX) {
    return configured
  }

  return isProductionBuild ? SOFTPHONE_TRANSPORTS.TELNYX : SOFTPHONE_TRANSPORTS.FAKE
}

/**
 * The Telnyx SDK is loaded in its own chunk so builds that never go online don't pay for it.
 */
export async function createSoftphoneTransport(transportName = getConfiguredTransportName()) {
  if (transportName === SOFTPHONE_TRANSPORTS.FAKE) {
    return new FakeSoftphoneTransport()
  }

  const { TelnyxSoftphoneTransport } = await import(/* webpackChunkName: "softphone-telnyx" */ './TelnyxSoftphoneTransport')

  return new TelnyxSoftphoneTransport()
}

/**
 * Publishes a fake transport on `window` so an e2e test can drive an inbound call. Stripped
 * from production builds: the whole body is behind a build-time constant webpack folds away.
 */
export function exposeSoftphoneDevHook(transport) {
  if (isProductionBuild || typeof window === 'undefined') {
    return
  }

  if (typeof transport?.simulateIncomingCall !== 'function') {
    return
  }

  window[SOFTPHONE_DEV_HOOK_KEY] = transport
}

export function removeSoftphoneDevHook() {
  if (isProductionBuild || typeof window === 'undefined') {
    return
  }

  delete window[SOFTPHONE_DEV_HOOK_KEY]
}
